import {linkSvg as Icon__small__linkSvg} from '../Icon__small/Icon__small--link.js';

export var link = {
  name: 'link',
  category: 'icon',
  colorable: true,
  svg: Icon__small__linkSvg,
};
